import { useNotifyHubSpotOnPageChange } from '@upright/ui/common/generic/hubspot';
import { ReactNode, createContext, useContext } from 'react';
import { useLoadMaintenanceMode } from './use-load-maintenance-mode';
import { useLoadOwnInfo } from './use-load-own-info';

interface RootContext {
  maintenanceModeText?: string;
}

const ctx = createContext<RootContext>({} as RootContext);
const Provider = ctx.Provider;

interface Props {
  children: ReactNode;
}

export function RootContextProvider(props: Props) {
  // these are loaded always, including all versions of mapper extension
  useLoadOwnInfo();

  useNotifyHubSpotOnPageChange();

  const maintenanceModeText = useLoadMaintenanceMode();
  const value = {
    maintenanceModeText,
  };
  return <Provider value={value}>{props.children}</Provider>;
}

export function useRootContext() {
  return useContext(ctx);
}
